import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    marginRight: theme.spacing(1),

    width: '100%',
  },
  profileIconLabel: {},
  listItemIcon: {
    maxWidth: 46,
  },
  profileName: {
    fontSize: 14,
    padding: 0,
    margin: 0,
  },
  profilRole: {
    textAlign: 'right',
    fontSize: 10,
    padding: 0,
    margin: 0,
  },
  applyButton: {
    borderRadius: '4px 4px 4px 4px',
    padding: theme.spacing(0, 1.5),
    margin: theme.spacing(0.7, -1.5, 0, 1),
    height: theme.spacing(4.5),
    color: '#4CAF50',
    fontSize: 14,
    textTransform: 'none',
    boxShadow: 'none',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #4CAF50',
    '&:hover': {
      boxShadow: 'none',
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), #4CAF50',
    },
  },
  preloader: {
    color: 'rgb(0 0 0 / 40%)',
    marginRight: theme.spacing(1),
  },
  profileIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
  },
  profileContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  IconContent: {
    display: 'flex',
    flexDirection: 'row',
  },
  MyProfileIcon: {
    width: '20%',
    color: 'grey',
  },
  imageStyling: {
    width: '25px',
    height: '20px',
  },

  IconContentEndUser: {
    display: 'flex',
    flexDirection: 'row',
  },
  MyProfileIconEndUser: {
    width: '30%',
    color: 'grey',
  },
  imageStylingEndUser: {
    width: '25px',
    height: '20px',
  },
}));
